import React from "react";
import { useTranslation } from "react-i18next";
import { Styles } from "./styles";

const SimpleCheckbox = ({ id, checked, onChange, label }) => {
  const { t } = useTranslation();

  return (
    <Styles htmlFor={id}>
      <input
        type="checkbox"
        id={id}
        className="simple-checkbox-input"
        checked={!!checked}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      <span className="simple-checkbox-label">{t(label)}</span>
    </Styles>
  );
};

export default SimpleCheckbox;
